exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mod[data-v-7c1d7a56]{margin-bottom:10px;background-color:#fff;background-size:contain;background-repeat:no-repeat}.mod[data-v-7c1d7a56]:last-of-type{margin-bottom:0}.mod.padding[data-v-7c1d7a56]{padding-bottom:16px}.vft_large .mod[data-v-7c1d7a56]{margin-bottom:9PX}.vft_large .mod.padding[data-v-7c1d7a56]{padding-bottom:20PX}.__darkmode__ .mod[data-v-7c1d7a56]{background-color:#0f0f1e}", ""]);

// exports
